var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachFileHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62467 3.50016V10.2085C9.62467 11.4977 8.58051 12.5418 7.29134 12.5418C6.00217 12.5418 4.95801 11.4977 4.95801 10.2085V2.91683C4.95801 2.11183 5.61134 1.4585 6.41634 1.4585C7.22134 1.4585 7.87467 2.11183 7.87467 2.91683V9.04183C7.87467 9.36266 7.61217 9.62516 7.29134 9.62516C6.97051 9.62516 6.70801 9.36266 6.70801 9.04183V3.50016H5.83301V9.04183C5.83301 9.84683 6.48634 10.5002 7.29134 10.5002C8.09634 10.5002 8.74967 9.84683 8.74967 9.04183V2.91683C8.74967 1.62766 7.70551 0.583496 6.41634 0.583496C5.12717 0.583496 4.08301 1.62766 4.08301 2.91683V10.2085C4.08301 11.9818 5.51801 13.4168 7.29134 13.4168C9.06467 13.4168 10.4997 11.9818 10.4997 10.2085V3.50016H9.62467Z",
    fill: "#A3AEBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileHome);
export default __webpack_public_path__ + "static/media/attachFileHome.7e2ee08c.svg";
export { ForwardRef as ReactComponent };